import {
  BoxProps,
  Box,
  Text,
  useColorModeValue,
  SlideFade,
  Stack,
  Avatar,
  Button,
  HStack,
  Icon,
  Wrap,
  Tag,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  IconButton,
} from "@chakra-ui/react";
import { HiShieldCheck, HiCash, HiLocationMarker } from "react-icons/hi";
import { MallProps } from "../../app/types";
import UpdateMallForm from "../../gen/Malls/UpdateMallForm";
import Form from "@rjsf/core";
import { RJSFSchema } from "@rjsf/utils";
import { useRef, useState } from "react";
import {
  useMallServiceDeleteMallMutation,
  MallServiceDeleteMallApiArg,
} from "../../app/genericApiGenerated";
import { FiTrash2, FiEdit2 } from "react-icons/fi";

const urls = [
  "https://res.cloudinary.com/westfielddg/image/upload/westfield-media/es/centre/logo/gwvnr73hn0mq4bj4zdgz.jpg",
  "https://res.cloudinary.com/westfielddg/image/upload/westfield-media/uk/centre/logo/bmvquofxlf9a4st1zcts.jpg",
  "https://res.cloudinary.com/westfielddg/image/upload/westfield-media/fr/centre/logo/koerarybof0fcosyrwwb.jpg",
];

const ModalDelete = ({
  isOpen,
  onClose,
  overlayStyle,
  initialRef,
  finalRef,
  deleteMall,
  selectedMallId,
}: any) => (
  <Modal isCentered isOpen={isOpen} onClose={onClose}>
    {overlayStyle}
    <ModalContent>
      <ModalHeader>Delete Mall</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>Are sure to delete this mall!</Text>
      </ModalBody>
      <ModalFooter>
        <Button
          colorScheme="red"
          mr={3}
          onClick={() => {
            if (selectedMallId) {
              deleteMall(selectedMallId.split("/")[1]);
              onClose();
            }
          }}
        >
          Delete
        </Button>
        <Button onClick={onClose}>Close</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

const ModalUpdate = ({
  isOpen,
  onClose,
  initialRef,
  finalRef,
  selectedMallId,
  updateMallFormRef,
}: any) => (
  <Modal
    initialFocusRef={initialRef}
    finalFocusRef={finalRef}
    isOpen={isOpen}
    onClose={onClose}
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>Update Mall</ModalHeader>
      <ModalCloseButton />
      <ModalBody pb={6}>
        <UpdateMallForm
          selectedMall={selectedMallId.split("/")[1] || ""}
          onFormSubmitted={() => onClose()}
          isOpen={isOpen}
          ref={updateMallFormRef}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          colorScheme="green"
          mr={3}
          onClick={() => {
            updateMallFormRef.current?.submit();
          }}
        >
          Update
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

const Card = (props: BoxProps) => (
  <Box
    mx="3"
    bg={useColorModeValue("white", "gray.700")}
    rounded={{ md: "xl" }}
    padding="10"
    shadow={{ md: "base" }}
    px={{ base: "6", md: "8" }}
    {...props}
  />
);
export function MallList({ malls }: MallProps) {
  const updateMallFormRef = useRef<Form<any, RJSFSchema, any>>(null);
  const [selectedMallId, setSelectedMallId] = useState<string>("");
  const [
    mallServiceDeleteMall, // This is the mutation trigger
  ] = useMallServiceDeleteMallMutation();

  function deleteMall(mallId: string): any {
    const mallArg: MallServiceDeleteMallApiArg = {
      mall: mallId,
    };

    mallServiceDeleteMall(mallArg)
      .unwrap()
      .then(() => {
        console.log("item deleted with id: ", mallId);
      });
  }
  const {
    isOpen: modalUpdateIsOpen,
    onOpen: modalUpdateOnOpen,
    onClose: modalUpdateOnClose,
  } = useDisclosure();
  const {
    isOpen: modalDeleteIsOpen,
    onOpen: modalDeleteOnOpen,
    onClose: modalDeleteOnClose,
  } = useDisclosure();
  const initialUpdateRef = useRef(null);
  const initialDeleteRef = useRef(null);
  const finalUpdateRef = useRef(null);
  const finalDeleteRef = useRef(null);
  const OverlayStyle = () => (
    <ModalOverlay
      bg="blackAlpha.300"
      backdropFilter="blur(10px) hue-rotate(90deg)"
    />
  );
  const [overlay, setOverlay] = useState(<OverlayStyle />);
  return (
    // malls.map((mall)=>{})
    <div>
      {/* {{malls.map((mall)=>{}}} */}
      {malls?.map((mall, index) => (
        <SlideFade
          in={true}
          offsetY="20px"
          transition={{ exit: { delay: 1 }, enter: { duration: 2 + index } }}
        >
          <Card marginBottom="5">
            <Stack
              direction={{ base: "column", md: "row" }}
              spacing={{ base: "3", md: "10" }}
              align="flex-start"
            >
              <Stack spacing="4">
                <Avatar size="2xl" src={urls[index]} name="Melinda Paul" />
                <Button
                  width="full"
                  colorScheme="blue"
                  display={{ base: "none", md: "initial" }}
                >
                  <a href={mall.website_uri}>Visit US</a>
                </Button>
              </Stack>
              <Box>
                <Stack
                  spacing={{ base: "1", md: "2" }}
                  direction={{ base: "column", md: "row" }}
                >
                  <Text as="h2" fontWeight="bold" fontSize="xl">
                    {mall.display_name}
                  </Text>
                  <HStack fontSize={{ base: "md", md: "lg" }}>
                    <Icon as={HiShieldCheck} color="green.500" />
                  </HStack>
                  <Box alignContent="left" alignItems="left">
                    <IconButton
                      icon={<FiTrash2 />}
                      variant="tertiary"
                      aria-label="Delete mall"
                      onClick={() => {
                        setSelectedMallId(mall.name as string); // Assuming 'id' is the identifier for a mall
                        modalDeleteOnOpen();
                      }}
                    />
                    <IconButton
                      icon={<FiEdit2 />}
                      variant="tertiary"
                      aria-label="Update mall"
                      onClick={() => {
                        setSelectedMallId(mall.name as string); // Assuming 'id' is the identifier for a mall
                        modalUpdateOnOpen();
                      }}
                    />
                  </Box>
                </Stack>
                <Text textAlign="left" as="p">
                  {mall.website_uri}
                </Text>
                <Wrap shouldWrapChildren my="4" spacing="4">
                  {/* <CustomerReviews reviewCount={84} rating={5.0} /> */}
                  <HStack>
                    <Icon as={HiCash} fontSize="xl" color="gray.400" />
                    <Text
                      fontSize="sm"
                      fontWeight="medium"
                      color={useColorModeValue("gray.600", "gray.300")}
                    >
                      {mall.opening_hours}
                    </Text>
                  </HStack>

                  <HStack spacing="1">
                    <Icon as={HiLocationMarker} color="gray.400" />
                    <Text
                      fontSize="sm"
                      fontWeight="medium"
                      color={useColorModeValue("gray.600", "gray.300")}
                    >
                      {mall.location_address}
                    </Text>
                  </HStack>
                </Wrap>
                <Box textAlign="left" fontSize="sm" noOfLines={2}>
                  {mall.description}
                </Box>
                <Wrap
                  shouldWrapChildren
                  mt="5"
                  color={useColorModeValue("gray.600", "gray.300")}
                >
                  {["Boutiques", "Services", "Offres", "Marques"].map((tag) => (
                    <Tag key={tag} color="inherit" px="3">
                      {tag}
                    </Tag>
                  ))}
                </Wrap>
              </Box>
            </Stack>
            <Button
              mt="8"
              width="full"
              colorScheme="blue"
              display={{ md: "none" }}
            >
              Contact me
            </Button>
          </Card>
        </SlideFade>
      ))}

      <ModalDelete
        isOpen={modalDeleteIsOpen}
        onClose={() => {
          modalDeleteOnClose();
          setSelectedMallId(""); // Reset the selectedMallId when the modal is closed
        }}
        initialRef={initialDeleteRef}
        finalRef={finalDeleteRef}
        overlayStyle={overlay}
        deleteMall={deleteMall}
        selectedMallId={selectedMallId}
      />
      <ModalUpdate
        isOpen={modalUpdateIsOpen}
        onClose={() => {
          modalUpdateOnClose();
          setSelectedMallId(""); // Reset the selectedMallId when the modal is closed
        }}
        initialRef={initialUpdateRef}
        finalRef={finalUpdateRef}
        updateMallFormRef={updateMallFormRef}
        selectedMallId={selectedMallId}
      />
    </div>
  );
}
